var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "9 46 66 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 55,l 0 2 5 0 0 -4 -5 0 0 -4 5 0 0 2,m 2 -2,l 2.5 8 2.5 -8,m 6.5 0,l -3.5 0 -1 1 0 6 1 1 3 0 1 -1 0 -3 -2 0,m 4 -4,l 0 8 5 0,m 2 -1,l 1 1 3 0 1 -1 0 -6 -1 -1 -3 0 -1 1 0 6,m 7 1,l 2.5 -8 2.5 8,m -1 -3,l -3 0,m 6 3,l 4 0 1 -1 0 -6 -1 -1 -4 0 0 8,m 10 0,l 0 -8 5 8 0 -8,m 6.5 0,l -3.5 0 -1 1 0 6 1 1 3 0 1 -1 0 -3 -2 0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "l1",
    x1: 59.5,
    y1: 57,
    x2: 59.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "c1",
    cx: 59.5,
    cy: 49.5,
    r: 0.2,
    fill: "#ff0000",
    stroke: "#ff0000"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    href: "#l1",
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    values: "0 0;0 -2;0 0;0 0",
    keyTimes: "0;0.1;0.2;1",
    dur: 1,
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    href: "#c1",
    attributeName: "transform",
    attributeType: "XML",
    type: "translate",
    values: "0 0;0 -3;0 0",
    keyTimes: "0;0.3;1",
    dur: 1,
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89965f3265e969e30a4942f53c6f7646.svg";
export { ForwardRef as ReactComponent };